export enum SUBMISSION_TYPE {
  STUDY = 'New Study for Initial Review',
  SITE = 'Add PI/Site to Existing Study',
  STUDY_SITE = 'Modification to Research',
}

export const SELECT_REGION_SUBMISSION_TYPES = [
  'Change In Research',
  'Contact Update',
  'Continuing Review',
  'Promptly Reportable Information',
  'Translation Request',
];

export const SELECT_MULTI_SITE_SUBMISSION_TYPES = [
  'Change In Research',
  'Contact Update',
  'Continuing Review',
  'Promptly Reportable Information',
  'Translation Request',
];

export const IRB_PLUS_SUBMISSION_TYPES = [
  'New Study for Initial Review',
  'Clinical Use of Humanitarian Use Device (HUD)',
];
